import React from "react";
import { siteConfig } from "../data/mockData";
import ContactForm from "../components/contact/ContactForm";
import ContactInfoSidebar from "../components/contact/ContactInfoSidebar";
import { Calendar } from "lucide-react";

const ContactPage = () => {
  return (
    <>
      {/* Hero */}
      <section className="pt-28 pb-16 bg-gradient-to-b from-[#F1F8F2] to-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <span className="text-sm font-semibold text-[#3A7D44] uppercase tracking-wider">
            Get In Touch
          </span>
          <h1
            className="text-4xl sm:text-5xl font-bold text-[#1B2A1B] mt-3 mb-6"
            style={{ fontFamily: "'DM Sans', sans-serif" }}
          >
            Let's Talk About Your Coverage
          </h1>
          <p className="text-lg text-[#5A6B5A] leading-relaxed max-w-2xl mx-auto mb-8">
            Whether you need a quote, want to book a call, or just have a
            question, I'm here to help. No pressure, no obligation.
          </p>
          <a
            href={siteConfig.calendlyUrl}
            
            
            className="inline-flex items-center gap-2 px-8 py-4 text-base font-semibold text-white bg-[#3A7D44] rounded-lg hover:bg-[#2D5A35] transition-colors shadow-lg shadow-[#3A7D44]/20"
          >
            <Calendar size={18} />
            Book a Free 15-Minute Call
          </a>
        </div>
      </section>

      {/* Contact Form + Info */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-5 gap-12">
            {/* Form */}
            <div className="lg:col-span-3">
              <div className="bg-white rounded-2xl border border-gray-100 p-8 shadow-sm">
                <h2 className="text-2xl font-bold text-[#1B2A1B] mb-2">
                  Or Send a Message
                </h2>
                <p className="text-sm text-[#5A6B5A] mb-8">
                  Prefer to write? Fill out the form below and I'll get back to
                  you within one business day.
                </p>
                <ContactForm />
              </div>
            </div>

            {/* Contact Info */}
            <div className="lg:col-span-2">
              <ContactInfoSidebar />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ContactPage;
